import { render, staticRenderFns } from "./CreateCampaign.vue?vue&type=template&id=96c3f116&scoped=true"
import script from "./CreateCampaign.vue?vue&type=script&lang=ts"
export * from "./CreateCampaign.vue?vue&type=script&lang=ts"
import style0 from "./CreateCampaign.vue?vue&type=style&index=0&id=96c3f116&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c3f116",
  null
  
)

export default component.exports